/* eslint-disable max-statements */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { sendCustomGaEvents } from "../../../tracking";
import { postInspectionDiyAuctionInProgressPageLoaded } from "../post-inspection-diy/tracking";
import PostInspectionDiyAuctionTimerWrapper from "../post-inspection-diy-auction-timer-wrapper";
import { NUMBER } from "../../../constants/app-constants";
import PostInspectionDiyContextBanner from "../post-inspection-diy-context-banner";
import PostInspectionDiyAuctionModal from "../post-inspection-diy-auction-modal";
import useMongoListener from "../../../hooks/use-mongo-listener";
import { MONOGO_DB_CONFIG } from "./constant";
import { Label } from "@cars24/turbo-web/lib/label";
import { Button } from "@cars24/turbo-web/lib/button";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { ButtonStack } from "@cars24/turbo-web/lib/button-stack";
import PostInspectionDiyModal from "../post-inspection-diy-modal";
import StopAuction from "./images/stop-auction.svg";

const PostInspectionDiyAuctionStart = ({
    inspectionResponse,
    setCurrentGaEventDetailsConnect,
    updateImpressionsConnect,
    stopAuctionConnect = () => { },
    getUpdatedDiyDetailsConnect = () => {}
}) => {
    const { tokens } = useTokens();
    const { appointmentId, auction, auctionId, token, featureData = {} } = inspectionResponse || {};
    const { stopOcbEnabled = false } = featureData || {};
    const { auctionEndTime, isReAuction = false } = auction || {};

    const { mongoData } = useMongoListener({
        auctionId,
        ...MONOGO_DB_CONFIG
    });

    const { cityId, geo: { lat = "", lng = "" } = {}, totalImpression} = mongoData || {};

    const [showAuctionProcess, setShowAuctionProcess] = useState(false);
    const [showEndAuctionPopup, setShowEndAuctionPopup] = useState(false);

    useEffect(() => {
        sendCustomGaEvents({
            ...postInspectionDiyAuctionInProgressPageLoaded,
            eventLabel: appointmentId
        });

        setCurrentGaEventDetailsConnect({
            gaEventName: "Auction page",
            eventCategory: "DIY_Auction"
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (cityId &&  lat && lng && totalImpression) {
            updateImpressionsConnect(mongoData);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cityId, lat, lng, totalImpression]);

    const showAuctionProcessHandler = () => {
        setShowAuctionProcess(prev => !prev);
    };

    const getClockTime = () => {
        const timeDiff = (new Date(auctionEndTime).getTime() - new Date().getTime()) / NUMBER.THOUSAND;
        return timeDiff.toFixed(NUMBER.ZERO);
    };

    const handlePopup = () => {
        setShowEndAuctionPopup(prev => !prev);
    };

    const handleEndAuction = () => {
        stopAuctionConnect(token)
            .then(() => {
                getUpdatedDiyDetailsConnect(token, <span>Fetching vehicle details</span>);
            });
    };

    return (
        <React.Fragment>
            <div>
                <h4 styleName={"styles.auctionHeader"}>{isReAuction ?
                    "We are finding a price closer to your expectation!" :
                    "Exciting news! Channel partners across India are checking out your car 🚗"}
                </h4>
                <PostInspectionDiyAuctionTimerWrapper
                    clockTimer={getClockTime()}
                />
                {stopOcbEnabled &&
                    <div styleName="styles.stopAuction">
                        <Label color={tokens.text_default_text_secondary} level={NUMBER.FOUR} fontWeight="regular">Interested in auctioning again at a lower asking price? </Label>
                        <Button
                            label="End auction"
                            onClick={handlePopup}
                            variant="tertiary"
                            size="small"
                        />
                    </div>}
                <PostInspectionDiyContextBanner
                    showContextScreen ={showAuctionProcessHandler}
                    heading = "How auction works?"
                />
            </div>
            {showAuctionProcess && <PostInspectionDiyAuctionModal showAuctionProcessHandler={showAuctionProcessHandler} />}
            {
                showEndAuctionPopup &&
                <PostInspectionDiyModal
                    height="auto"
                    isOpen={true}
                    width="520px"
                    showCloseButton={true}
                    onClose={handlePopup}
                >
                    <div styleName="styles.stopAuctionModal">
                        <Heading level={NUMBER.FOUR} isBold>Ending auction!</Heading>
                        <BodyText level={3} color={tokens.text_default_text_secondary}>You won't be able to auction again at this or a higher price</BodyText>
                        <img src={StopAuction} alt="stop_auction" />
                    </div>
                    <ButtonStack layout="vertical">
                        <Button label="Continue auction" size="large" variant="primary" onClick={handlePopup} />
                        <Button label="End auction" size="large" variant="destructive" onClick={handleEndAuction} />
                    </ButtonStack>
                </PostInspectionDiyModal>
            }
        </React.Fragment>
    );
};

PostInspectionDiyAuctionStart.propTypes = {
    title: PropTypes.string,
    inspectionResponse: PropTypes.object,
    setCurrentGaEventDetailsConnect: PropTypes.func,
    getUpdatedDiyDetailsConnect: PropTypes.func,
    updateImpressionsConnect: PropTypes.func,
    stopAuctionConnect: PropTypes.func
};

export default PostInspectionDiyAuctionStart;

